import React from 'react';
import { lazyAfterPaint } from 'react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder';
import { OnboardingNudgeErrorBoundary } from '../onboarding-nudge-error-boundary';
import type { QuickstartNudgeProps, QuickstartNudgeType } from './types';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyQuickstartNudge = lazyAfterPaint<QuickstartNudgeType>(
	() =>
		import(/* webpackChunkName: "async-software-quickstart-nudge" */ './main').then(
			(exportedModule) => exportedModule.QuickstartNudge,
		),
	{
		ssr: false,
	},
);

export const QuickstartNudge = ({ children = null, ...props }: QuickstartNudgeProps) => (
	<OnboardingNudgeErrorBoundary
		id="quickstartNudge"
		fallback={children}
		attributes={{ nudgeId: props.nudgeId }}
	>
		<Placeholder name="software-quickstart-nudge" fallback={children}>
			<LazyQuickstartNudge {...props}>{children}</LazyQuickstartNudge>
		</Placeholder>
	</OnboardingNudgeErrorBoundary>
);
